import { Component, OnInit, VERSION } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormControl, NgModel } from '@angular/forms';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-farmer-assessment',
  templateUrl: './farmer-assessment.component.html',
  styleUrls: ['./farmer-assessment.component.css']
})
export class FarmerAssessmentComponent implements OnInit {

  Actioncmg: UntypedFormGroup;
  constructor(
    private spinner: NgxSpinnerService
    , private fb: UntypedFormBuilder
  ) {
    this.Actioncmg = this.fb.group({
      selecyear: '',
      selectzone: '',
      date: '',
      comment: '',
      fmcode: '',
      term: '',
      title_id: '',
      lock: this.sub_topic
    })
  }
  ngOnInit(): void {
    this.LoadAllFm(0, '');
    this.LoadZone();
    this.Loadmain_topic();
  }
  zonecode = [];
  SubTraindata = [];
  dataAr = [];
  AlldataFm = [];

  LoadZone() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url).then(res => {
      this.zonecode = (res.data.recordset);
    }).catch(err => { throw (err) })
  }

  main_topic = [];
  sub_topic = [];
  all_topic = [];
  Loadmain_topic() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=[id],[name],[type],left([type],1)[Ltype]&f=[CPS6263].[dbo].[knowledge]&w=[status]=1";
    axios.get(url).then(res => {
      if (res.data.rowsAffected[0] >= 1) {
        let data = res.data.recordset;
        data.sort(function (a: any, b: any) { return b.type - a.type });
        data = data.map(item => {
          return { ...item, completed: false };
        });
        this.all_topic = data;
        this.main_topic = data.filter((el) => el.type.substr(-1, 1) == '0');
        this.sub_topic = data.filter((el) => el.type.substr(-1, 1) != '0');
        /*console.log('main_topic',this.main_topic);
        console.log('sub_topic',this.sub_topic);
        */
      }
    }).catch(err => { throw (err) })
  }
  dataAft = [];
  loadDataFT(setv: number) {
    let jsS = this.sub_topic.filter((el) => el.completed == true);
    let lstData = [0]
    if (setv == 1) {
      let lenArr = jsS.length
      for (let i = 0; i < lenArr; i++) { lstData.push(jsS[i].id); }
      this.dataAft = lstData;
    }
    else if (setv == 2) {
      let lenArr = this.sub_topic.length
      for (let i = 0; i < lenArr; i++) { this.sub_topic[i].completed = false }
      this.dataAft = [];
      //console.log('sub_topic',this.sub_topic);
    }
    /*
    console.log('jsS',jsS);
    console.log('dataAft',this.dataAft);
    */
  }

  LoadAllFm(typeC = 0, fmcode = '') {
    this.spinner.show();
    let fm1 = '', url: string;
    if (typeC != 0) { fm1 = `and [FMCODE_B1]='` + fmcode + `'` }

    url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=[FMCODE_B1][FMCODE],[fmname],[SUPZONE],isnull([knowledge],0)knowledge&f=CPS6263.dbo.t_farmer&w=area0=1` + fm1 + ``;
    axios.get(url).then(res => {
      if (res.data.length >= 1) {
        this.spinner.hide();
        if (typeC != 0) {
          if (this.AlldataFm.length > 0) {
            this.AlldataFm = this.AlldataFm.filter((el) => el.FMCODE != fmcode);
            this.AlldataFm.push(res.data[0])
            console.log('data[0]', res.data[0]);
            setTimeout(() => {
              this.svFm();
            }, 100);
          } else { this.AlldataFm = (res.data); }
        } else { this.AlldataFm = (res.data); }
      }
      else {
        alert("ไม่สามารถโหลด " + 'ข้อมูลชาวไร่ได้' + " ได้");
      }
    }).catch(err => { throw (err) })
  }

  saveKnowledge() {
    let fmcode: string = this.fmSelect[0].FMCODE
      , value = this.dataAft
    if (fmcode.length > 0) {
      if (confirm('ต้องการบันทึกความรู้ชาวไร่ โควตา [' + fmcode + '] หรือไม่?')) {
        this.spinner.show();
        let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[dbo].[t_farmer]&s=[knowledge]='` + value + `'&w=FMCODE_B1='` + fmcode + `'`;
        axios.get(url).then(res => {
          if (res.data.rowsAffected[0] >= 1) {
            this.spinner.hide();
            alert(fmcode + " บันทึกข้อมูลสำเร็จ ");
            this.LoadAllFm(1, fmcode);
          }
          else {
            alert("ไม่สามารถบันทึกได้");
          }
        }).catch(err => { throw (err) })
      }
    } else alert("โปรดเลือกชาวไร่");
  }

  fmSelect = [];
  setFMdata(fmcode) {
    this.loadDataFT(2);
    this.fmSelect = this.AlldataFm.filter(el => el.FMCODE == fmcode);
    let numeArr = [], arrd = [], arre = '', arrf = (this.fmSelect[0].knowledge)
    if (arrf.startsWith('0') && arrf.length > 2) {
      arre = arrf.split(',');
      arrd.push(arre);
      numeArr = arrd[0].map(id => parseInt(id));
    }

    console.log('numeArr', numeArr.length, numeArr);
    // Loop ตาม id ที่ต้องการอัปเดต    
    for (let i = 0; i < numeArr.length; i++) {
      let id = numeArr[i]; // ค้นหาข้อมูลที่ต้องการอัปเดตด้วย id
      const dataToUpdate = this.sub_topic.find(data => data.id == id); // ถ้าพบข้อมูล ให้อัปเดตค่า completed เป็น true
      if (dataToUpdate) {
        dataToUpdate.completed = true;
      }
      //console.log('i:',i,'id:',id); 
    }
    //console.log('sub_topic',this.sub_topic);
    this.loadDataFT(1);
  }

  dataResult = [];
  svFm() {//
    let txa = this.Actioncmg.value
    let zone = txa.selectzone, txt = txa.term
    let keyword = (txt).toLowerCase();
    if (keyword.length > 0) {
      if (zone == '') { this.dataResult = this.AlldataFm.filter((el) => (el.FMCODE.toLowerCase().indexOf(keyword) > -1 || el.fmname.toLowerCase().indexOf(keyword) > -1)); }
      else { this.dataResult = this.AlldataFm.filter((el) => el.SUPZONE == zone && (el.FMCODE.toLowerCase().indexOf(keyword) > -1 || el.fmname.toLowerCase().indexOf(keyword) > -1)); }
    }
  }


  THtoLocalstring(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

  THtoLocalstring2(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }
}
